<template>
  <div>
    <vs-popup title="Properties" :active.sync="InPropertiesMenu" v-if="InPropertiesMenu">
      <TabContainer :onboarding="selectedOnboarding"></TabContainer>
    </vs-popup>
    <vs-popup title="Link" :active.sync="AfterShare" v-if="AfterShare">
      Link:
      <p v-if="AfterShare">{{onboardingLink}}</p>
    </vs-popup>

    <vs-popup title="Create Space" :active.sync="InSpaceCreationMode" v-if="InSpaceCreationMode">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Title:"
                    v-model="spaceTitle" />
        </div>
        <div class="vx-col md:w-1/1 w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Description"
                    v-model="spaceDescription" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button @click="CreateSpace()">Create Space</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- No Items State -->
    <NoItemsCard v-if="onboardings.length === 0 && !isLoading " />

    <!-- Three Carousel Sections Row -->
    <div v-if="onboardings.length > 0" class="vx-row carousel-sections-row">
      <!-- Featured Onboardings Carousel -->
      <div class="vx-col w-full lg:w-1/3 mb-base" v-if="featuredOnboardings.length > 0">
        <OnboardingCarousel 
          :onboardings="featuredOnboardings"
          :title="$t('Latest')"
          :autoplay="false"
          :slides-per-view="1"
          :space-between="20"
          @card-click="handleCarouselCardClick"
        />
      </div>

      <!-- Most Useful Onboardings Carousel -->
      <div class="vx-col w-full lg:w-1/3 mb-base" v-if="mostUsefulOnboardings.length > 0">
        <OnboardingCarousel 
          :onboardings="mostUsefulOnboardings"
          :title="$t('MostUseful')"
          :autoplay="false"
          :slides-per-view="1"
          :space-between="20"
          @card-click="handleCarouselCardClick"
        />
      </div>

      <!-- Role-Based Onboardings Carousel -->
      <div class="vx-col w-full lg:w-1/3 mb-base" v-if="roleBasedOnboardings.length > 0">
        <OnboardingCarousel 
          :onboardings="roleBasedOnboardings"
          :title="$t('TailoredForYou')"
          :autoplay="false"
          :slides-per-view="1"
          :space-between="20"
          @card-click="handleCarouselCardClick"
        />
      </div>
    </div>
    
    <!-- Browse Section -->
    <div v-if="onboardings.length > 0">
      <br/>
      <h1>{{$t('Browse')}}</h1>
      <br>
      <div class="vx-row" style="clear:both;">
        <div v-for="(onboarding) in GetItems()" :key="onboarding.Id"
             class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
          <OnboardingCard :onboarding ="onboarding"></OnboardingCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DeleteOnboardingLink from '@/views/components/atoms/onboardings/DeleteOnboardingLink'
  import OnboardingCard from '@/views/components/organisms/cards/OnboardingCard.vue'
  import TabContainer from '@/views/ui-elements/tabs/TabContainer.vue'
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import OnboardingCarousel from '@/components/OnboardingCarousel.vue';
  import NoItemsCard from '@/components/NoItemsCard.vue';
  //import tiptap from "@/views/components/extra-components/editors/tiptap.vue";

  export default {
    data() {
      return {
        itemsPerPage: 20,
        onboardings: [],
        featuredOnboardings: [],
        mostUsefulOnboardings: [],
        roleBasedOnboardings: [],
        spaceTitle: "",
        isLoading:true,
        spaceDescription: "",
        InSpaceCreationMode: false,
        selectedOnboarding: null,
        InPropertiesMenu: false,
        AfterShare: false,
        ItemsForCurrentUrl: null,
        FilteredOnboardings: [],
        FilterByCurrentUrl: false
      }
    },
    mounted() {
      window.winAppMessage = function (data) {
        if (data && data.length > 0) {
          TCVelikClient.GetRelative("/api/search?query=**&shortResults=true&urlContext=" + data)
            .then(function (result) {
              instance.ItemsForCurrentUrl = result.data.map(itm => itm.Id * 1);
              instance.FilteredOnboardings = instance.onboardings.filter(item => instance.ItemsForCurrentUrl.includes(item.id));
            });
        }
        else {
          // alert('')
        }
      }

      var instance = this;
      var req = JSON.stringify({
        query: `query Onboardings {
                    onboardings(order: {
                        id:DESC
                    }) {
                      id
                      name,
                      description,
                      properties,
                      firstImage,
                      currentUserStats
                    }
                  }`});

      TCVelikClient.PostRelative("/api/graphql", req, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      }).then(function (response) {
        if (response && response.data && response.data.data) {
          instance.onboardings = response.data.data.onboardings;
          
          // Set featured onboardings (first 6 with images or descriptions)
          instance.featuredOnboardings = instance.onboardings
            .filter(item => item.firstImage || (item.description && item.description.length > 50))
            .slice(0, 6);
          
          // Set most useful onboardings (next 6, excluding featured ones)
          const remainingAfterFeatured = instance.onboardings.filter(item => 
            !instance.featuredOnboardings.includes(item)
          );

          instance.mostUsefulOnboardings = instance.onboardings.slice(0, 6);
          
          // Set role-based onboardings (remaining items, excluding featured and most useful)
          const remainingAfterMostUseful = remainingAfterFeatured.filter(item => 
            !instance.mostUsefulOnboardings.includes(item)
          );
          instance.roleBasedOnboardings = remainingAfterMostUseful.slice(0, 6);
        }

        instance.isLoading = false
      });

      window.addEventListener('message', function (event) {
      });
    },
    methods: {
      GetItems() {
        if (this.FilterByCurrentUrl) {
          return this.FilteredOnboardings;
        }
        return this.onboardings;
      },

      OpenProperties(onboarding) {
        this.InPropertiesMenu = true;
        this.selectedOnboarding = onboarding
      },
      OpenSpaceCreationMenu() {
        this.InSpaceCreationMode = true;
      },
      isOnboardingCompleted(onboarding) {
        return onboarding.currentUserStats != null && onboarding.currentUserStats == 'COMPLETED';
      },

      OpenOnboarding(id) {
        if (document.body.getAttribute("notcv") == "true") {
          window.location.href = '/pages/liveguide/' + id;
        }
        else {
          window.open('/pages/pdf-view?oid=' + id)
        }
      },
      handleCarouselCardClick(onboarding) {
        this.OpenOnboarding(onboarding.id);
      },
      CreateSpace() {
        var instance = this
        const spaceVariables = {
          id: 0,
          title: instance.spaceTitle,
          description: instance.spaceDescription,
          icon: "",
          urlName: ""
        }
        const query = `
      mutation AddSpace($space: SpaceInput!) {
        addSpace(entity: $space) {
          id,
          title,
          description,
          icon,
          urlName
          }
       }
      `;
        const variables = {
          space: spaceVariables
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data) {

            instance.$vs.notify({
              title: "Success!",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }
        });

      },

      SaveChanges(onboarding) {
        const query = `
          mutation UpdateOnboarding($onboarding: OnboardingInput!) {
            updateMainFields(
              entity: $onboarding
            ) {
              id,
              name
              description
              rawContent
            }
          }
        `;

        const variables = {
          onboarding: onboarding
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            alert("You're good to go.");
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      },
    },
    components: {
      DeleteOnboardingLink,
      TabContainer,
      FeatherIcon,
      OnboardingCard,
      OnboardingCarousel,
      NoItemsCard
    }
  }
</script>
<style>
  body {
    background: #fff;
    padding: 20px;
  }

  .layout--full-page {
    height: 500px;
  }

  .onboarding-recorder.email .vs-collapse-item {
    background: white !important;
  }

  .onboarding-recorder.email .vs-collapse-item--header {
    background: white !important;
  }

  .onboarding-recorder.email .step-tools {
    display: none !important;
  }

  .onboarding-recorder.email .icon-header {
    display: none !important;
  }

  .onboarding-recorder.email .screenshot {
    max-width: 300px !important;
  }

  .pointer {
    cursor: pointer;
  }

  .commands {
    position: fixed;
    bottom: 0px;
  }

  .full-height {
    height: 100%;
  }

  img.screenshot {
    max-width: 80%;
    opacity: 0.8;
  }

  .onboarding-recorder .vs-collapse-item--header {
    background: #efefef;
    margin-bottom: 10px;
  }

  /* Carousel Sections Row Styles */
  .carousel-sections-row {
    margin-bottom: 2rem;
  }

  .carousel-sections-row .vx-col {
    padding: 0 10px;
  }

  /* Ensure carousels in the row have consistent height */
  .carousel-sections-row .onboarding-carousel-wrapper {
    height: 100%;
  }

  .carousel-sections-row .onboarding-carousel {
    height: 350px;
  }

  /* Mobile adjustments for the row layout */
  @media (max-width: 1024px) {
    .carousel-sections-row .onboarding-carousel {
      height: 400px;
    }
  }

  @media (max-width: 768px) {
    .carousel-sections-row .onboarding-carousel {
      height: 450px;
    }
  }

</style>
